// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2UPvE","footer":"ModalInfo_footer__1NwIL"};